export class SelectableItemDto {
    item :any;
    isSelected :boolean;

    constructor(item :any, isSelected :boolean){
        this.item = item;
        this.isSelected = isSelected;
    }
}